import { post } from './common';
const policyApiPrefix = '/InternalAPI/PolicyAPI.asmx';
export const toggleAuditAutoInquire = async (newValue) => {
    const result = (await (await post(`${policyApiPrefix}/ToggleAuditAutoInquire`, {
        strValue: newValue.toString()
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
export const toggleAuditInquiryEditable = async (newValue) => {
    const result = (await (await post(`${policyApiPrefix}/ToggleAuditInquiryEditable`, {
        strValue: newValue.toString()
    })).json()).d;
    if (result.Status !== 'success') {
        throw new Error(result.Message);
    }
    return JSON.parse(result.Data);
};
